import React, { useState, useEffect } from "react";
import { BASE_URL } from "../utils/config";
import {  useNavigate } from "react-router-dom";
import Sidebar from "../components/sidebar";
import { Toolbar } from "primereact/toolbar";
import {
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  Button,
} from "@mui/material";
import DownloadIcon from "@mui/icons-material/Download";
import Stack from "@mui/material/Stack";
import Loading from "../components/loading";
import LevelRecord from "../components/stocklevelTable";

import { Tabs, Tab } from "@mui/material";
import ReactSelect from 'react-select'
import TelegramWidget from "../components/widget/telegramWidget";

const StockLevel = () => {
 const navigate = useNavigate();
  const [IndicesRecord, setIndicesRecord] = useState([]);
  const [CommodityRecord, setCommodityRecord] = useState([]);
  const [StockRecord, setStockRecord] = useState([]);
  const [options, setOptions] = useState([]);
  const [AddDialog, setAddDialog] = useState(false);
  const [loading, setLoading] = useState(true);

  const [value, setValue] = useState(0);
  const [IndicesRecordTab, setIndicesRecordTab] = useState(true);
  const [CommodityRecordTab, setCommodityRecordTab] = useState(false);
  const [StockRecordTab, setStockRecordTab] = useState(false);
  const [successDialog, setSuccessDialog] = useState(false);
  const [errorDialog, setErrorDialog] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [levelStateData, setLevelStateData] = useState({
    stock_symbol :null,
    r_one :null,
    r_two : null,
    r_three :null,
    pivot_point : null,
    s_one : null,
    s_two : null,
    s_three : null,
    StockType : null
  })
  const [RoneError, setRoneError] = useState(false);
  const [RtwoError, setRtwoError] = useState(false);
  const [RthreeError, setRthreeError] = useState(false);
  const [pivotPointError, setPivotPointError] = useState(false);
  const [SoneError, setSoneError] = useState(false);
  const [StwoError, setStwoError] = useState(false);
  const [SthreeError, setSthreeError] = useState(false);
  const [heading, setHeading] = useState('Indices Level')
  const [email,setEmail] = useState('');
  let count = 0;
  const optionType = [
    {
    value: 'Indices',
    label: 'Indices',
  },
    {
    value: 'Commodity',
    label: 'Commodity',
  },
    {
    value: 'Stock',
    label: 'Stock',
  }
]

  const customStyles = {
    // Define your custom styles here
    menu: (provided) => ({
      ...provided,
      width: '256px',
    }),
    control: (provided, state) => ({
      ...provided,
      width: '256px', // Set the desired width for the entire component
      border: '1px solid #ccc',
      borderRadius: '4px',
      boxShadow: state.isFocused ? '0 0 0 1px #2684FF' : null,
      '&:hover': {
        border: '1px solid #2684FF',
      },
    }),
    // Add more styles for other elements as needed
  };

  useEffect(() => {
    if (count === 0) {
      fetchrecord();
      const details = JSON.parse(localStorage.getItem('userdetails'));
      setEmail(details.email_address)
      count += 1;
    }
  }, []);

  //  this function is used to fetch record
  const fetchrecord = async () => {
    console.log("inside fetch record ")
    const loginuser = JSON.parse(localStorage.getItem('loginData'));
    try {
      await fetch(`${BASE_URL}/getalllevel`, {
        method: "GET",
        headers: {
          'Authorization': `Bearer ${loginuser.token}`
        }
      })
        .then((response) => response.json())
        .then((res) => {
          if (res.success === true) {
            console.log(
              "automate scritp date for record stock selection",
              res.levelIndicesData[0],
              res.levelCommodityData[0],
              res.levelStockData[0]
            );

            setIndicesRecord(res.levelIndicesData[0]);
            setCommodityRecord(res.levelCommodityData[0]);
            setStockRecord(res.levelStockData[0])
            // console.log("res.stockSymbols[0]",res.stockSymbols)
            const optionData = res.stockSymbols.map((data) => ({
              ...data,
              value: data.StockName,
              label: data.StockName,
            }));

            setOptions(optionData);

            setHeading('Indices Level')
            setValue(0)
            setIndicesRecordTab(true)
            setLoading(false);

            // console.log("lot_size",res.lot_size)
          }else if(res.status === 403){ 
            setTimeout(()=>{
              localStorage.clear()
               navigate('/login')
            },3000) 
          }
          else if(res.status === 401){
            setTimeout(()=>{
              localStorage.clear()
               navigate('/login')
            },3000) 
          } else {
            console.log("data not found");
            setLoading(false);
            setErrorMessage(`Error: ${res.message}`);
            setErrorDialog(true);
            setTimeout(() => {
              setErrorDialog(false)
              setErrorMessage('')
            }, 2000);
          }
        })
        .catch((error) => {
          console.error("Error fetching data:", error);
          setLoading(false);
          setErrorMessage(`Error: ${error.message}`);
          setErrorDialog(true);
          setTimeout(() => {
            setErrorDialog(false)
            setErrorMessage('')
          }, 2000);
        });
    } catch (error) {
      console.error("Error fetching data:", error);
      setErrorMessage(`Error: ${error.message}`);
      setErrorDialog(true);
      setTimeout(() => {
        setErrorDialog(false)
        setErrorMessage('')
      }, 2000);
    }
  };




//  left toolbar
  const leftToolbarTemplate = () => {
    return (
      <div className="centerToolbarTemplate">
        <Tabs value={value} onChange={handleChange}>
          <Tab
            style={{ padding: 0, fontSize: "13px" }}
            label={`Indices`}
            onClick={(e) => {
              handletabSelection(e, "Indices");
            }}
          />

          <Tab
            style={{ padding: 0, fontSize: "13px" }}
            label={`Commodity`}
            onClick={(e) => {
              handletabSelection(e, "Commodity");
            }}
          />
          <Tab
            style={{ padding: 0, fontSize: "13px" }}
            label={`Stocks`}
            onClick={(e) => {
              handletabSelection(e, "Stocks");
            }}
          />
        </Tabs>
      </div>
    );

  };

  //  right toolbar
  const rightToolbarTemplate = () => {
    return (
      <div className="flex flex-wrap gap-2 table-prehead-right">
        <Stack direction="row" spacing={2}>
          <Button
            variant="contained"

            onClick={handleAddStockAction}
          >
            Add New Record
          </Button>

          <Button
            variant="contained"
            endIcon={<DownloadIcon />}
            onClick={exportCSV}
          >
            Export
          </Button>
        </Stack>
      </div>
    );
  };

  // center toolbar
  const centerToolbarTemplate = () => {
    return (
      <>
        <h2 style={{ marginTop: "0px" }}>{heading}</h2>
      </>
    );
  };

  // this function is used to handle change values
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  //  this function is used to select tab selection
  const handletabSelection = async (event, type) => {
    console.log("type form signle click", type);

    if (type === "Indices") {
      setStockRecordTab(false);
      setCommodityRecordTab(false);
      // setSelectedItems([]);
      setIndicesRecordTab(true);
      setHeading('Indices Level')

    } else if (type === "Commodity") {
      setIndicesRecordTab(false);
      setStockRecordTab(false);

      // setSelectedItems([]);
      setCommodityRecordTab(true);
      setHeading('Commodity Level')

    }
    else if (type === "Stocks") {

      setIndicesRecordTab(false);
      setCommodityRecordTab(false);
      // setSelectedItems([]);

      setStockRecordTab(true);
      setHeading('Stock Level')
    }
  };

//  this function is used to open a popup model to add new stock level
  const handleAddStockAction = async () => {
    console.log("inside add stock dialog")
    setAddDialog(true);
  }




//  this function is used to export csv

  const exportCSV = () => {
    import("xlsx").then((xlsx) => {
      try {
        // Convert the array of objects to a worksheet
        let worksheet 

        if(heading === 'Indices Level'){
           worksheet = xlsx.utils.json_to_sheet(IndicesRecord);
        }else if(heading === 'Commodity Level'){
          worksheet = xlsx.utils.json_to_sheet(CommodityRecord);
        }else if(heading === 'Stock Level'){
          worksheet = xlsx.utils.json_to_sheet(StockRecord);
        }else{
          alert('Please Select valid Option to Export Excel.')
        }

        // Convert the worksheet to a CSV file
        const csvContent = xlsx.utils.sheet_to_csv(worksheet);

        // Save the CSV file
        saveAsCSVFile(csvContent, heading);
      } catch (error) {
        console.error("Error exporting data to CSV:", error);
      }
    });
  };

  //  this function is used to save csv file
  const saveAsCSVFile = (content, fileName) => {
    import("file-saver").then((module) => {
      if (module && module.default) {
        const CSV_EXTENSION = ".csv";

        const data = new Blob([content], {
          type: "text/csv;charset=utf-8",
        });

        module.default.saveAs(data, fileName + CSV_EXTENSION);
      }
    });

  };

// this function is used to change in stock  input
  const handlechangestock = async (event) => {
    // const { name, value } = event.target;
    console.log("event",event)
    setLevelStateData((prevState) => ({
      ...prevState,
      stock_symbol:  event.value,
    }));
  }

  // this function is used to change in stock type input
  const handlechangestockType = async (event) => {
    // const { name, value } = event.target;
  console.log("event",event)
    setLevelStateData((prevState) => ({
         ...prevState,
          StockType: event.value,
    }));
  }

  // this function is used to change in table values  input
  const handleInputChange = (event) => {
 console.log("level",levelStateData)
    const { name, value } = event.target;
    if (/^\d*\.?\d{0,2}$/.test(value)) {
      setLevelStateData((prevState) => ({
            ...prevState,
            [name]: value,
      }));
    }else {
       switch (name) {
        case 'r_one':
          setRoneError(true);
          setTimeout(() => setRoneError(false), 2000);
          break;
        case 'r_two':
          setRtwoError(true);
          setTimeout(() => setRtwoError(false), 2000);
          break;
        case 'r_three':
          setRthreeError(true);
          setTimeout(() => setRthreeError(false), 2000);
          break;
        case 'pivot_point':
          setPivotPointError(true);
          setTimeout(() => setPivotPointError(false), 2000);
          break;
        case 's_one':
          setSoneError(true);
          setTimeout(() => setSoneError(false), 2000);
          break;
        case 's_two':
          setStwoError(true);
          setTimeout(() => setStwoError(false), 2000);
          break;
        case 's_three':
          setSthreeError(true);
          setTimeout(() => setSthreeError(false), 2000);
          break;
        default:
          break;
      }
    }
   

  };

  //  this is used to submit the form

  const handleSubmit = async () => {
    try{
    console.log("inside form submit")
    
    const details = JSON.parse(localStorage.getItem('loginData'));
   let body =   JSON.stringify({
      levelData: levelStateData,
      createdBy: details.user_id
    })

    console.log("inside form submit",body)
    await fetch(`${BASE_URL}/createlevel`, {
      method: 'POST',
      body: body,
      headers: {
        "Content-Type": "application/json",
         'Authorization': `Bearer ${details.token}`
      },
    })
      .then(response => response.json())
      .then(res => {
        // Process the API response data
        console.log("Level Response ===================res ", res);

        if (res.success === true) {
          setAddDialog(false)
          setLevelStateData({
            stock_symbol :null,
            r_one :null,
            r_two : null,
            r_three :null,
            pivot_point : null,
            s_one : null,
            s_two : null,
            s_three : null,
            StockType : null
          })
          setSuccessMessage('Level Record Successfully created.')
         setSuccessDialog(true)
         fetchrecord();
         setTimeout(()=>{
         
          setSuccessDialog(false)
          setSuccessMessage('')

         },2000)
        }else if(res.status === 403){ 
          setTimeout(()=>{
            localStorage.clear()
             navigate('/login')
          },3000) 
        }
        else if(res.status === 401){
          setTimeout(()=>{
            localStorage.clear()
             navigate('/login')
          },3000) 
        }else{
        
          setLevelStateData({
            stock_symbol :null,
            r_one :null,
            r_two : null,
            r_three :null,
            pivot_point : null,
            s_one : null,
            s_two : null,
            s_three : null,
            StockType : null
          })
          setErrorMessage(`Error: ${res.message}`);
            setErrorDialog(true);
            setTimeout(() => {
              setErrorDialog(false)
              setErrorMessage('')
            }, 2000);
        }
      })
      .catch(error => {
       console.error('Error fetching data:', error);
       
       setLevelStateData({
        stock_symbol :null,
        r_one :null,
        r_two : null,
        r_three :null,
        pivot_point : null,
        s_one : null,
        s_two : null,
        s_three : null,
        StockType : null
       })
       setErrorMessage(`Error: ${error.message}`);
            setErrorDialog(true);
            setTimeout(() => {
              setErrorDialog(false)
              setErrorMessage('')
            }, 2000);
      });
    }catch(error){
      setErrorMessage(`Error: ${error.message}`);
            setErrorDialog(true);
            setTimeout(() => {
              setErrorDialog(false)
              setErrorMessage('')
            }, 2000); 
    }
  }










  return (
    <>
      <Sidebar />
      {loading ? (
        <div
          style={{
            position: "fixed",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            zIndex: 2,
          }}
        >
          <Loading />
        </div>
      ) : (
        <div className="add-user user-list">
          <Toolbar
            className="table-pre-head"
            start={leftToolbarTemplate}
            end={rightToolbarTemplate}
            center={centerToolbarTemplate}
          ></Toolbar>
          {IndicesRecordTab ? (
            <LevelRecord RecordData={IndicesRecord} heading={'Indices Level'} updaterecord={fetchrecord} Email={email}/>
          ) : CommodityRecordTab ? (
            <LevelRecord RecordData={CommodityRecord} heading={'Commodity Level'} updaterecord={fetchrecord} Email={email} />
          ) : StockRecordTab ? (
            <LevelRecord RecordData={StockRecord} heading={'Stocks Level'} updaterecord={fetchrecord} Email={email} />
          ) : null}

<TelegramWidget/>
          {/*Error Message Dialog */}
          <Dialog
            open={errorDialog}
            onClose={() => { setErrorDialog(false) }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              <h4 style={{ color: "red" }}>Failure</h4>
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">


                {errorMessage}


              </DialogContentText>
            </DialogContent>

          </Dialog>

          {/*Success Message Dialog */}
          <Dialog
            open={successDialog}
            onClose={() => { setSuccessDialog(false) }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
          >
            <DialogTitle id="alert-dialog-title">
              <h4 style={{ color: "green" }}>Success</h4>

            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">


                <span style={{ color: "black" }}>
                  {successMessage}
                </span>


              </DialogContentText>
            </DialogContent>

          </Dialog>

          {/* add new stock dialog */}
          
              <Dialog
      open={AddDialog}
      onClose={() => setAddDialog(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      maxWidth="md" // Setting maxWidth to 'md' (medium size)
      fullWidth // Ensuring the dialog takes the full width allowed by maxWidth
      PaperProps={{
        style: {
          width: '60%',
          height: '80vh',
          margin: 'auto', // Center the dialog
        },
      }}
    >
      <DialogTitle id="alert-dialog-title">
        <h4 style={{ color: 'black' }}> Add New Stock</h4>
      </DialogTitle>
      <DialogContent>
        <div>
          

          <div style={{ display: 'flex', flexWrap: 'wrap', gap: '16px' }}>
          <div style={{ width: '48%' }}>
              <p>Stock Symbol:<span className='asterisk'>*</span></p>
              <ReactSelect
                id="stock_symbol"
                name="stock_symbol"
                options={options}
                onChange={handlechangestock}
                styles={customStyles}
              />
            </div>


            <div style={{ width: '48%' }}>
              <p>Stock Type:<span className='asterisk'>*</span></p>
              <ReactSelect
                id="StockType"
                name="StockType"
                options={optionType}
                onChange={handlechangestockType}
                styles={customStyles}
              />
            </div>


            <div style={{ width: '48%' }}>
              <p>R-ONE:</p>
              <input
                value={levelStateData.r_one}
                type="number"
                id="r_one"
                name="r_one"
                onChange={handleInputChange}
                style={{width: '256px'}}
              />
              {RoneError && <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span>}
            </div>

            <div style={{ width: '48%' }}>
              <p>R-Two:</p>
              <input
                value={levelStateData.r_two}
                type="number"
                id="r_two"
                name="r_two"
                onChange={handleInputChange}
                style={{width: '256px'}}
              />
              {RtwoError && <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span>}
            </div>

            <div style={{ width: '48%' }}>
              <p>R-Three:</p>
              <input
                value={levelStateData.r_three}
                type="number"
                id="r_three"
                name="r_three"
                style={{width: '256px'}}
                onChange={handleInputChange}
              />
              {RthreeError && <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span>}
            </div>

            <div style={{ width: '48%' }}>
              <p>Pivot Point:</p>
              <input
                value={levelStateData.pivot_point}
                type="number"
                id="pivot_point"
                name="pivot_point"
                style={{width: '256px'}}
                onChange={handleInputChange}
              />
              {pivotPointError && <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span>}
            </div>

            <div style={{ width: '48%' }}>
              <p>S-One:</p>
              <input
                value={levelStateData.s_one}
                type="number"
                id="s_one"
                name="s_one"
                style={{width: '256px'}}
                onChange={handleInputChange}
              />
              {SoneError && <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span>}
            </div>

            <div style={{ width: '48%' }}>
              <p>S-Two:</p>
              <input
                value={levelStateData.s_two}
                type="number"
                id="s_two"
                name="s_two"
                style={{width: '256px'}}
                onChange={handleInputChange}
              />
              {StwoError && <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span>}
            </div>

            <div style={{ width: '48%' }}>
              <p>S-Three:</p>
              <input
                value={levelStateData.s_three}
                type="number"
                id="s_three"
                name="s_three"
                style={{width: '256px'}}
                onChange={handleInputChange}
              />
              {SthreeError && <span style={{ color: 'red', fontSize: '15px' }}>Numeric input with 2 decimal places (0-9).</span>}
            </div>
          </div>
        </div>
      </DialogContent>
      <DialogActions style={{display:'flex', justifyContent: 'flex-end' }}>
        <Button style={{color:'white',backgroundColor:'#23499E'}} onClick={() => setAddDialog(false)} >
          Cancel
        </Button>
        <Button onClick={handleSubmit}style={{color:'white',backgroundColor:'#23499E'}}>
          Submit
        </Button>
      </DialogActions>
    </Dialog>


        </div>
      )}
    </>
  );
};

export default StockLevel;
